import React from 'react'
import PropTypes from 'prop-types'
import { capitalizeFirstLetter } from '../../../../helpers/string'

export const DeliveryHourRow = ({ row, dayName, index }) =>
  row === null
    ? <tr/>
    : <tr id={dayName + index}>
      <td name="dayOfWeek">
        {index === 0 ? capitalizeFirstLetter(dayName) : ''}
      </td>
      <td name="startTime" className={row.closed ? 'lineThrough' : ''}>
        {row.poolTimes[index].startTime}
      </td>
      <td name="endTime" className={row.closed ? 'lineThrough' : ''}>
        {row.poolTimes[index].endTime}
      </td>
      <td name="closedForTheDay">
        {index === 0 ? (row.closed ? "Closed" : "Open") : ''}
      </td>
      <td />
    </tr>

DeliveryHourRow.propTypes = {
  row: PropTypes.shape({
    closed: PropTypes.bool,
    poolTimes: PropTypes.arrayOf(PropTypes.shape({
      startTime: PropTypes.string,
      endTime: PropTypes.string
    })).isRequired
  }),
  dayName: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/deliveryHours/deliveryHourRow.js